import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Breadcrumbs } from "../components";
import Table from "../components/table/Table";
import { useBank, useProject } from "../hooks";

function AurusGroupPage() {
  const [plotData, setPlotData] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const { getAllPlots } = useProject();
  const { getAurusBankDetails, updateBankDetails, addBankAccount } = useBank();

  useEffect(() => {
    const fetchAllPlots = async () => {
      const { plots, error } = await getAllPlots();
      if (error) return toast.error(error);
      setPlotData(plots);
    };
    fetchAllPlots();
  }, []);

  const fetchAurusBanks = async () => {
    const { banks, error } = await getAurusBankDetails();
    if (error) {
      toast.error(error);
    }
    setBankDetails(banks);
  };
  useEffect(() => {
    // fetchAurusBanks();
  }, []);

  const handleAddBank = async (newData) => {
    const data = {
      ...newData,
      bank_branch_name: newData.bank_branch,
      bank_identification_id: newData.bank_identification,
    };
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.id;
    const { success, error } = await addBankAccount("aurus_group", userId, data);
    if (error) {
      toast.error(error);
      return;
    }
    toast.success(success);
    await fetchAurusBanks();
  };

  const handleEditBank = async (editedData, bankId) => {
    const dataToUpdate = { ...editedData };
    if (Object.keys(editedData).includes("bank_branch")) {
      dataToUpdate.bank_branch_name = editedData.bank_branch;
    }
    if (Object.keys(editedData).includes("bank_identification")) {
      dataToUpdate.bank_identification_id = editedData.bank_identification;
    }
    const { success, error } = await updateBankDetails(bankId, dataToUpdate);
    if (error) return toast.error(error);
    toast.success(success);
    fetchAurusBanks();
  };

  const plotListHeaders = [
    { id: "project_name", name: "Project Name" },
    { id: "total_commission", name: "Total Commission" },
    { id: "total_withdrawable", name: "Total Withdrawable" },
    { id: "total_withdrawn", name: "Total Withdrawn" },
    {
      id: "total_upcoming_in_future_installments",
      name: "Total Upcoming in future installments",
    },
    // { id: "total_registration_charges", name: "Total Registration Charges" },
    // { id: "registration_charges_received", name: "Registration Charges Received" },
    // { id: "total_development_charges", name: "Total Development Charges" },
    // { id: "development_charges_received", name: "Development Charges Received" },
  ];

  return (
    <>
      <Breadcrumbs breadcrumbs={[{ name: "Aurus" }]} />
      <section className="page_wrapper">
        <Table columns={plotListHeaders} data={plotData} title="All Plots" isFullLength={true} />
      </section>
    </>
  );
}

export default AurusGroupPage;
